"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Return the current field's active error.
 *
 * @param fieldProps The react-final-form field render props.
 */

exports.getFieldError = function (fieldProps) {
  var meta = fieldProps.meta;
  return meta.touched && meta.error || !meta.dirtySinceLastSubmit && meta.submitError;
};
/**
 * Extract from a BaseFieldProps object only props that can be safely passed down to input elements
 * This functions removes the Field specific props made available by the usage of BaseFieldProps
 */


function extractInputProps(fieldProps) {
  var label = fieldProps.label,
      hasWrapper = fieldProps.hasWrapper,
      parse = fieldProps.parse,
      format = fieldProps.format,
      convert = fieldProps.convert,
      validate = fieldProps.validate,
      rest = __rest(fieldProps, ["label", "hasWrapper", "parse", "format", "convert", "validate"]);

  return rest;
}

exports.extractInputProps = extractInputProps;